<template>
  <div id="app" class="flex-column">
    <nav>
      <header class="logTitle flex-yCenter">
        <img v-if="sys.logo" :src="sys.logo" alt="" class="pointer" @click="$router.push('/login')" /><span></span>
        <div class="fweight600 fsize22">{{sys.name}}</div>
      </header>
    </nav>
    <!--  底部  -->
    <div class="brand-footer" :style="bomPath.includes($router.currentRoute.path)?{'background-color': 'transparent !important'}:''">
      <span class="fcolor_gray2">Copyright © {{$store.state.user.unitName}}</span>
    </div>
    <router-view />
  </div>
</template>
<script>
import { systemConfigSysLogo, systemConfigSysName } from '@/utils/api'
import {systemConfigSysBackgroundImage,systemConfigSysUnitName} from "@/utils/api";
export default {
  data() {
    return {
      sys:{
        name:'',
        logo:''
      },
      bomPath:['/login','/register']
    }
  },
  created() {
    systemConfigSysBackgroundImage('sys.logo').then(res => {
      this.$store.state.user.backgroundImage = res.msg
    })
    systemConfigSysUnitName('sys.logo').then(res => {
      this.$store.state.user.unitName = res.msg
    })
    systemConfigSysLogo().then(res => {
      if(res.code==200){
        this.sys.logo=res.msg
      }
    })
    systemConfigSysName().then(res => {
      if(res.code==200){
        this.sys.name=res.msg
      }
    })
  }
}
</script>
<style lang="scss" scoped>
#app {
  flex-grow: 1;
}

nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }

  .logTitle {
    height: 110px;
    box-sizing: border-box;
    padding: 16px 0 24px 24px;

    &>img {
      height: 70px;
      width: 250px;
      background-size: 100% 100%;
    }

    &>span {
      height: 44px;
      display: block;
      width: 1px;
      background-color: rgba(0, 0, 0, 0.3);
      margin: 0 16px 0 8px;
    }
  }
}
</style>
